import React, { useRef, useState } from 'react';
import { FormGroup, Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { setDefinedServicesPopup, getDefinedServicesForSelect } from "../../store/api/TaskDetailsApi";
import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Info, InfoCircle } from 'react-bootstrap-icons';
const ModalDefinedServices = () => {
    const definedServicePopStatus = useSelector(state => state.taskDetails.definedServicePopStatus);
    const [definedServiceList, setList] = useState(null);
    const justForProduct = useRef(false);
    const dispatch = useDispatch();
    const search = () => {
        let itemDesc = document.getElementsByName("ItemDescForSeach")[0].value;
        const data = {
            ItemDesc: itemDesc,
            ProductID: definedServicePopStatus.productID,
            JustForProduct: justForProduct.current
        }
        if (Number(definedServicePopStatus.gType) !== 1) {
            data.ProductTypeID = definedServicePopStatus.productTypeID;
        }
        getDefinedServicesForSelect(data, setList);
    }
    const select = (id, desc, code, cost) => {
        var data = {};
        data.ID = id;
        data.Description = desc;
        data.Code = code;
        data.Cost = cost;
        if (definedServicePopStatus.setDefinedServiceData) {
            definedServicePopStatus.setDefinedServiceData(data);
        }
        dispatch(setDefinedServicesPopup({ status: 'hide' }));
    }
    function close() {
        justForProduct.current = false;
        dispatch(setDefinedServicesPopup({ status: 'hide' }));
    }
    return (
        <Modal size='lg' show={definedServicePopStatus.status === 'show'} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faListAlt} size='lg' />&nbsp; انتخاب تعرفه از لیست
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={close} /></Modal.Header>
            <Modal.Body className='bodyStyle'>
                <div className="row">
                    <div>
                        <input type='checkbox' className='form-check-input' onChange={e => justForProduct.current = e.target.checked} />&nbsp;
                        تعرفه های مرتبط با این محصول
                    </div>
                    <div className="form-group">
                        <input type="text" name="ItemDescForSeach" placeholder="شرح تعرفه" className="form-control" />
                    </div>
                </div>
                <button type="button" className="btn btn-primary w-100 mt-2" onClick={search}>جستجو</button>
                <br />
                <br />
                <div className='scThin' style={{ maxHeight: "250px", overflow: "auto" }}>
                    <Table className='mb-0'>
                        <thead>
                            <tr>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#b6b6b6" }}>شرح تعرفه</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#b6b6b6" }}>مبلغ تعرفه</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#b6b6b6" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {!definedServiceList || definedServiceList === "Pending" &&
                                <tr><td colSpan={2} style={{ textAlign: "center" }}> <Loader type="BallTriangle" color="#bb1370" height={30} width={30} /></td></tr>}
                            {Array.isArray(definedServiceList?.Data) &&

                                definedServiceList.Data.map((item, i) => {
                                    return <tr className="resultTableRow" key={i} onClick={() => select(item.ID, item.ItemDesc, item.ItemCode, item.ItemCost)}>
                                        <td>
                                            {item.ItemDesc}
                                        </td>
                                        <td>{item.ItemCost.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                        <td>
                                            {item.ItemLongDesc?.length > 0 &&
                                                <button className="rowBtn btn tooltipBtn" style={{ padding: 0, marginRight: "3px" }} data-tooltip={item.ItemLongDesc}>
                                                    <InfoCircle size={18} color='orange' />
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                })}
                        </tbody>

                    </Table>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalDefinedServices;